import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { routers } from './routes_path'

export  function Routers() {
  return (
    <RouterProvider router={routers} />
  )
}
